export default __webpack_public_path__ + "static/eccles-2ea549538c260add1b215be3836f1068.svg";